import React from "react";
import {TrackHeaderLink} from "../TrackHeaderLink";
import {WorkOrderTable} from "./WorkOrderTable";


export class WorkOrder extends React.Component {

  render() {
    return <div id="main-content">
      <div className="container-fluid">
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-sm-2 col-12">
              <h3 className="main-heading">AB Tracks</h3>
            </div>
            <div className="col-sm-10 col-12">
              <TrackHeaderLink/>
            </div>
          </div>
          <WorkOrderTable/>
        </div>
      </div>

    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/pages/tracks/workorder/WorkOrderQuote.jsx